<ng-template #navTile>
  <div [ngClass]="{ active }" class="nav-tile flex flex-col flex-center-stretch sm:flex-start-stretch">
    <div class="nav-tile-header sm:typography-small-header sm:font-bold">
      {{ navItem?.title }}
    </div>
    <div class="nav-tile-desc typography-paragraph text-12 max-sm:hidden">
      {{ navItem?.description }}
    </div>
  </div>
</ng-template>

@if (!navItem?.external) {
  <a [attr.data-test-id]="navItemId" [routerLink]="navItem?.link" (click)="selected$.emit(navItem)" mat-button>
    <ng-container *ngTemplateOutlet="navTile"></ng-container>
  </a>
}
@if (navItem?.external) {
  <a
    [attr.data-test-id]="navItemId"
    (click)="selected$.emit(navItem)"
    href="{{ navItem?.link }}"
    mat-button
    target="_blank"
  >
    <ng-container *ngTemplateOutlet="navTile"></ng-container>
  </a>
}
